<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>Clientes </strong>asociados a {{ LOCAL_DATA.nombre }}
</h1>
<div mat-dialog-content>
    <div class="content p-24" fxFlex="100" fxLayout="column">
        <table
            mat-table
            [dataSource]="LOCAL_DATA.clientes"
            #mytable
            class="my-table mat-elevation-z8"
            fxFlex="100"
        >
            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
            </ng-container>

            <ng-container matColumnDef="pais">
                <th mat-header-cell *matHeaderCellDef>País</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.direccion.pais }}
                </td>
            </ng-container>

            <ng-container matColumnDef="direccion">
                <th mat-header-cell *matHeaderCellDef>Dirección</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.direccion.calle }}
                    {{ element.direccion.numeroDePuerta }},
                    {{ element.direccion.numeroDeApartamento }},
                    {{ element.direccion.localidad }}
                </td>
            </ng-container>

            <ng-container matColumnDef="documentoDeIdentidad">
                <th mat-header-cell *matHeaderCellDef>
                    Documento de identidad
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.documento.tipo }} |
                    {{ element.documento.numero }}
                </td>
            </ng-container>

            <ng-container matColumnDef="actividadPrincipal">
                <th mat-header-cell *matHeaderCellDef>Actividad principal</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.actividadPrincipal.nombre }}
                </td>
            </ng-container>

            <ng-container matColumnDef="fechaNacimiento">
                <th mat-header-cell *matHeaderCellDef>
                    Fecha de nacimiento/constitución
                </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.fechaDeNacimiento | date : "dd/MM/yyyy" }}
                    {{ element.fechaDeConstitucion | date : "dd/MM/yyyy" }}
                </td>
            </ng-container>

            <ng-container matColumnDef="pep">
                <th mat-header-cell *matHeaderCellDef>
                    Persona políticamente expuesta
                </th>
                <td mat-cell *matCellDef="let element">{{ element.pep }}</td>
            </ng-container>

            <ng-container matColumnDef="correoElectronico">
                <th mat-header-cell *matHeaderCellDef>Correo</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.correoElectronico }}
                </td>
            </ng-container>

            <ng-container matColumnDef="telefono">
                <th mat-header-cell *matHeaderCellDef>Teléfono</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.telefono }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Salir" | translate }}
    </button>
</div>
